/* eslint-disable import/default */
/* eslint-disable indent */

import React from 'react';
import styled from 'styled-components';
import Checkbox from './Checkbox';

const Container = styled.div``;

const ChoiceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;
`;

const Choice = styled.div<{
    left?: boolean;
    right?: boolean;
    selected: boolean;
    isDetailMode: boolean;
}>`
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    width: 90%;
    padding: 8px;
    border-radius: 8px;

    cursor: ${({ isDetailMode }) => (isDetailMode ? 'not-allowed' : 'pointer')};
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 12px;
    border: ${({ selected }) => (selected ? '2px solid black' : '2px solid transparent')};
    :hover {
        transform: scale(1.03);
    }
    transition: all 0.4s ease;
`;

const Title = styled.h3`
    text-align: center;
`;

const DescriptionList = styled.ul`
    margin: 8px;
    padding: 8px;
`;
const DescriptionItem = styled.li<{ isE2EFlow: boolean }>`
    margin: 8px;
    transition: color 0.5s;

    color: ${({ isE2EFlow }) => (isE2EFlow ? 'rgba(0,0,0)' : 'rgba(0, 0, 0, 0.5)')};

    &::marker {
        transition: color 0.5s;
        content: '➤ ';
        color: ${({ isE2EFlow }) => (isE2EFlow ? 'green' : 'rgba(0, 0, 0, 0.1)')};
    }
`;

const CheckBoxContainer = styled.div`
    border: 1px solid black;
    margin-top: auto;
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;
`;

const FlowChoices = ({
    isE2EFlow,
    setIsE2EFlow,
    isDetailMode,
}: {
    isE2EFlow: boolean;
    setIsE2EFlow: any;
    isDetailMode: boolean;
}) => {
    return (
        <Container>
            <ChoiceContainer>
                <Choice
                    onClick={() => !isDetailMode && setIsE2EFlow(false)}
                    selected={!isE2EFlow}
                    isDetailMode={isDetailMode}
                    left
                >
                    <Title>Normal Flow</Title>
                    <DescriptionList>
                        <DescriptionItem isE2EFlow={!isE2EFlow}>
                            This client is using the current configuration, check out JSON transform, Webhook Forward
                            etc
                        </DescriptionItem>
                    </DescriptionList>
                    <CheckBoxContainer>
                        <Checkbox id="Normal Flow" checked={!isE2EFlow} text="Select Normal Flow" />
                    </CheckBoxContainer>
                </Choice>
                <Choice
                    onClick={() => !isDetailMode && setIsE2EFlow(true)}
                    selected={isE2EFlow}
                    isDetailMode={isDetailMode}
                    right
                >
                    <Title>E2E Flow</Title>
                    <DescriptionList>
                        <DescriptionItem isE2EFlow={isE2EFlow}>
                            This client is now using the E2E Flow, when receiving a <i>/v2/jobs</i> request, it will add
                            in req <i>req.safeFields.e2eFlow : true</i>. Once reaching the JobService, createJob will do
                            its normal job but call <i>/v2/jobs/scheduled</i> instead
                        </DescriptionItem>
                        <DescriptionItem isE2EFlow={isE2EFlow}>
                            This client is still affected by all all the configuration ( JSON transform, Webhook Forward
                            etc ). You should disable api forwarding to routingTool.
                        </DescriptionItem>
                    </DescriptionList>
                    <CheckBoxContainer>
                        <Checkbox id="E2EFlow" checked={isE2EFlow} text="Select E2E Flow" />
                    </CheckBoxContainer>
                </Choice>
            </ChoiceContainer>
        </Container>
    );
};

export default FlowChoices;
